import { useState } from 'react';
import type BackendService from '../../../services/admin/BackendService';
import type { VideoMetadata } from '../../../services/admin/adminBackendServiceVideoLibraryMixin';
import { errText } from './videoLibraryErrorText';

/** Upload state + action for the video library: reports failures via `uploadError`. */
export function useVideoLibraryUpload(
  backendService: BackendService,
  fundOpportunityId: string,
  refresh: () => Promise<void>,
) {
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);

  /** Resolves to whether the upload succeeded (failures are reported via `uploadError`). */
  const upload = async (metadata: VideoMetadata, file: File): Promise<boolean> => {
    setUploading(true);
    setUploadError(null);
    try {
      await backendService.uploadVideoToLibrary(metadata, fundOpportunityId, file);
      await refresh();
      return true;
    } catch (err) {
      setUploadError(errText(err));
      return false;
    } finally {
      setUploading(false);
    }
  };

  return { uploading, uploadError, upload, dismissUploadError: () => setUploadError(null) };
}
